<template>
  <header :class="{ 'navbar': true, scroll }">
    <router-link to="/">
      <img class="logo" src="../../assets/images/logo.png" alt="Heldengame" />
    </router-link>
    <navigation />
  </header>
</template>

<script>
import Navigation from '@/components/home/Navigation.vue'

export default {
  name: 'Header',
  components: {
    Navigation
  },
  data () {
    return {
      scroll: false
    }
  },
  created () {
    window.onscroll = () => {
      this.scroll = window.scrollY > 360
    }
  }
}
</script>

<style scoped lang="scss">
.navbar {
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 99.2rem;
  background-color: $color-silver;

  &.scroll .logo {
    width: 24rem;
  }
}

.logo {
  position: absolute;
  top: 0;
  left: 1.5rem;
  width: 36rem;
  height: auto;
  transition: all 400ms;
}
</style>
